import { Fragment } from "react";

function EmptyState({
  title = "You're all caught up!",
  text = "No new updates right now — we'll notify you when there's something to review",
  imageSrc = `${process.env.PUBLIC_URL}/images/empty_page.svg`,
  className = "",
}) {
  return (
    <Fragment>
      <div className={`empty-state ${className}`}>
        <div className="empty-state-content">
          <img
            src={imageSrc}
            alt={title}
            className="empty-state-icon"
          />
          <h4 className="empty-state-title">{title}</h4>
          <p className="empty-state-text">{text}</p>
        </div>
      </div>
    </Fragment>
  );
}

export default EmptyState;
